var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.cls},[(_vm.isAccessible)?_c(_vm.componentType,{tag:"component",attrs:{"config":_vm.config,"height":_vm.height}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }